import React, { useEffect, useState } from 'react';
import { HiCheckCircle, HiXCircle, HiInformationCircle, HiExclamation, HiX } from 'react-icons/hi';

/**
 * DESIGN.md toast.
 *  - success = mint bg + forest text
 *  - error = signature-coral bg + white text
 *  - warning = cream bg + ink text
 *  - info = surface-soft + info text
 *  10px radius, hairline border, soft shadow.
 */
const Toast = ({ message, type = 'info', duration = 5000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duration]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) onClose();
        }, 300);
    };

    if (!isVisible) return null;

    const types = {
        success: {
            icon: HiCheckCircle,
            container: 'bg-signature-mint border-hairline text-signature-forest'
        },
        error: {
            icon: HiXCircle,
            container: 'bg-signature-coral border-transparent text-white'
        },
        warning: {
            icon: HiExclamation,
            container: 'bg-signature-cream border-hairline text-ink'
        },
        info: {
            icon: HiInformationCircle,
            container: 'bg-surface-soft border-hairline text-info'
        }
    };

    const config = types[type] || types.info;
    const Icon = config.icon;

    return (
        <div
            className={`flex items-center gap-3 min-w-[300px] max-w-md p-4 rounded-md border shadow-card transition-all duration-300 ${config.container} ${
                isExiting ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
            }`}
        >
            <Icon className="text-2xl flex-shrink-0" />
            <p className="flex-1 text-body-md font-medium">
                {message}
            </p>
            <button
                onClick={handleClose}
                className="flex-shrink-0 p-1 rounded-sm hover:bg-ink/10 transition-colors"
            >
                <HiX className="text-lg" />
            </button>
        </div>
    );
};

export default Toast;
